
export enum StepTypes {
  FIXED = 'fixed',
  TOGGLE = 'option',
  TOGGLE_SELECTION = 'option2',
  FIXED_SELECTION = 'fixedSelection'
}
